import { db, functions, auth } from "./firebase.js";
import { collection, query, where, orderBy, limit, doc, getDoc, getDocs, addDoc, updateDoc, deleteDoc, Timestamp, onSnapshot } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";

const googleProvider = new GoogleAuthProvider();

export function signIn() {
  return signInWithPopup(auth, googleProvider);
}

export function signOut() {
  return auth.signOut();
}

export function subscribeMarketplaceTeams(cb) {
  const q = query(
    collection(db, "marketplace_teams"),
    where("status", "==", "published"),
    orderBy("installCount", "desc"),
    limit(50)
  );
  return onSnapshot(q, (snap) => cb(snap.docs.map((d) => ({ id: d.id, ...d.data() }))));
}

export function subscribeMarketplaceTeam(slug, cb) {
  const q = query(collection(db, "marketplace_teams"), where("slug", "==", slug), limit(1));
  return onSnapshot(q, (snap) => cb(snap.docs.length > 0 ? { id: snap.docs[0].id, ...snap.docs[0].data() } : null));
}

export function subscribeMyTeams(cb) {
  const user = auth.currentUser;
  if (!user) { cb([]); return () => {}; }
  const q = query(collection(db, "marketplace_teams"), where("ownerId", "==", user.uid));
  return onSnapshot(q, (snap) => cb(snap.docs.map((d) => ({ id: d.id, ...d.data() }))));
}

export function subscribeReviews(teamId, cb) {
  const q = query(collection(db, "marketplace_teams", teamId, "reviews"), orderBy("createdAt", "desc"), limit(20));
  return onSnapshot(q, (snap) => cb(snap.docs.map((d) => ({ id: d.id, ...d.data() }))));
}

export async function getTeamVersions(teamId) {
  const snap = await getDocs(collection(db, "marketplace_teams", teamId, "versions"));
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function getUserSpaces() {
  const user = auth.currentUser;
  if (!user) return [];
  const q = query(collection(db, "spaces"), where("ownerId", "==", user.uid));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function createSpace(name) {
  const user = auth.currentUser;
  if (!user) throw new Error("Not authenticated");
  const ref = await addDoc(collection(db, "spaces"), {
    name,
    ownerId: user.uid,
    ownerName: user.displayName || user.email,
    createdAt: Timestamp.now(),
    language: "en",
    agentRole: "",
  });
  return ref.id;
}

export const searchMarketplace = httpsCallable(functions, "searchMarketplace");
export const installMarketplaceTeam = httpsCallable(functions, "installMarketplaceTeam");
export const publishMarketplaceTeam = httpsCallable(functions, "publishMarketplaceTeam");
export const unpublishMarketplaceTeam = httpsCallable(functions, "unpublishMarketplaceTeam");
export const addMarketplaceReview = httpsCallable(functions, "addMarketplaceReview");
export const translateOnDemand = httpsCallable(functions, "translateOnDemand");
export const createStripeCheckout = httpsCallable(functions, "createStripeCheckout");
